// Module
var code = "<section class=\"cr-simple-picker\"> <cr-filter-menu route-query-id=\"timeframe\" title=\"{{ ::$ctrl.label }}\" hide-reset-option=\"true\" menu-align-right=\"$ctrl.menuAlignRight\" options=\"$ctrl.simplePickerData\" on-select=\"$ctrl.optionSelected(option)\" default-filter-id=\"{{ ::$ctrl.defaultRange }}\"></cr-filter-menu> </section> ";
// Exports
export default code;